// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  hmr: false,
  // apiUrl:"https://rf9p4ck28j.execute-api.us-east-1.amazonaws.com/prod",
  apiUrl:"https://rhsmfu8j81.execute-api.us-east-1.amazonaws.com/qa",

  //AWS CONFIG QA
  region: 'us-east-1',
  userPoolId: 'us-east-1_kNwqdD53w',
  userPoolWebClientId: '5rb4g7an2035bsfkdnortsjorp'

  //AWS CONFIG PROD
  // region: 'us-east-1',
  // userPoolId: 'us-east-1_9UD7QtuxJ',
  // userPoolWebClientId: '30s1g3cfctgo94fnimf0oodbuo'

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
